'use client';

import React from 'react';
import Link from 'next/link';

const concepts = [
  { label: 'THE LENS AS BRIDGE', desc: 'The Inner Reality Lens is not a wall separating the spiritual from the material. It is a bridge — what you perceive inwardly, you carry outwardly into service.' },
  { label: 'TAQWAH AS SERVICE', desc: 'Individual God-Consciousness manifests as collective caretaking. The one who sees clearly serves clearly. Taqwah is not withdrawal — it is the most engaged presence.' },
  { label: 'FISABILILLAH', desc: 'In the way of Allah. Not for recognition, not for transaction — but as an expression of the Amanah. The open toolkit exists fisabilillah.' },
  { label: 'A GARDEN WITH NO WALLS', desc: "For us, by us. The resource guide is not a charity — it is a community of caretakers recognizing each other's Amanah and supporting its fulfillment." },
];

export default function BridgeRGTransition() {
  return (
    <section className="py-20 border-t" style={{ background: 'rgba(10,20,16,0.7)', borderColor: 'rgba(139,105,20,0.15)' }}>
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">

        {/* Transition label */}
        <div className="flex items-center gap-4 mb-12">
          <div className="h-px flex-1" style={{ background: 'linear-gradient(90deg, transparent, rgba(139,105,20,0.3))' }} />
          <div className="text-center">
            <p className="font-mono text-[9px] tracking-widest uppercase mb-1" style={{ color: 'rgba(139,105,20,0.5)' }}>Bridge 03 · Passage</p>
            <p className="font-mono text-xs tracking-widest uppercase" style={{ color: 'rgba(245,240,232,0.25)' }}>Inner Reality Lens → Muslim Resource Guide</p>
          </div>
          <div className="h-px flex-1" style={{ background: 'linear-gradient(90deg, rgba(139,105,20,0.3), transparent)' }} />
        </div>

        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="font-mono text-2xl md:text-3xl font-black uppercase tracking-tight mb-4" style={{ color: '#F5F0E8' }}>
            FROM SELF<br /><span style={{ color: 'rgba(179,138,42,0.8)' }}>TO COMMUNITY</span>
          </h2>
          <p className="font-mono text-sm max-w-xl mx-auto leading-relaxed" style={{ color: 'rgba(245,240,232,0.4)' }}>
            The lens is a bridge, not a wall. Individual taqwah manifests as community service. The open toolkit — a garden with no walls, for us by us.
          </p>
        </div>

        {/* Concepts grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px mb-12" style={{ background: 'rgba(139,105,20,0.1)' }}>
          {concepts?.map((c) => (
            <div key={c?.label} className="p-8 transition-colors duration-300" style={{ background: 'rgba(10,20,16,0.8)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(28,43,37,0.6)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(10,20,16,0.8)'; }}
            >
              <p className="font-mono text-xs font-black tracking-widest uppercase mb-4" style={{ color: 'rgba(179,138,42,0.7)' }}>{c?.label}</p>
              <p className="font-mono text-sm leading-relaxed" style={{ color: 'rgba(245,240,232,0.35)' }}>{c?.desc}</p>
            </div>
          ))}
        </div>

        {/* Bridge visual */}
        <div className="max-w-2xl mx-auto mb-10">
          <div className="flex items-center gap-4">
            <div className="flex-1 px-5 py-4 text-center" style={{ border: '1px solid rgba(139,105,20,0.2)' }}>
              <p className="font-mono text-xs font-black tracking-widest uppercase" style={{ color: 'rgba(245,240,232,0.35)' }}>INNER REALITY LENS</p>
              <p className="font-mono text-[9px] mt-1" style={{ color: 'rgba(245,240,232,0.2)' }}>Individual Perception</p>
            </div>
            <div className="flex flex-col items-center gap-1">
              <div className="w-px h-6" style={{ background: 'rgba(139,105,20,0.3)' }} />
              <div className="w-1.5 h-1.5 rotate-45" style={{ background: 'rgba(179,138,42,0.5)' }} />
              <div className="w-px h-6" style={{ background: 'rgba(139,105,20,0.3)' }} />
            </div>
            <div className="flex-1 px-5 py-4 text-center" style={{ border: '1px solid rgba(139,105,20,0.2)' }}>
              <p className="font-mono text-xs font-black tracking-widest uppercase" style={{ color: 'rgba(245,240,232,0.35)' }}>MUSLIM RESOURCE GUIDE</p>
              <p className="font-mono text-[9px] mt-1" style={{ color: 'rgba(245,240,232,0.2)' }}>Collective Caretaking</p>
            </div>
          </div>
          <p className="font-mono text-[9px] text-center mt-3" style={{ color: 'rgba(139,105,20,0.4)' }}>Fisabilillah — In the Way of Allah</p>
        </div>

        <div className="flex items-center justify-center gap-6">
          <Link href="/muslim-resource-guide"
            className="font-mono text-xs tracking-widest uppercase px-6 py-3 transition-colors"
            style={{ background: 'rgba(139,105,20,0.85)', color: '#F5F0E8', border: '1px solid rgba(179,138,42,0.35)' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(179,138,42,0.95)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.background = 'rgba(139,105,20,0.85)'; }}
          >
            Muslim Resource Guide →
          </Link>
          <Link href="/bridge-resource-guide"
            className="font-mono text-[10px] tracking-widest uppercase transition-colors border-b"
            style={{ color: 'rgba(245,240,232,0.3)', borderColor: 'rgba(139,105,20,0.2)' }}
            onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.7)'; }}
            onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(245,240,232,0.3)'; }}
          >
            Full Bridge 03 →
          </Link>
        </div>
      </div>
    </section>
  );
}
